import * as React from 'react'

import ContractGroup from '../tabs/contracts/views/ContractGroup'

import { RouteComponentProps } from '@/app/navigation/withRouter'
interface RouteParams {
  companyId: string
}

export const DriverGroupContractsPage: React.FC<
  RouteComponentProps<RouteParams>
> = ({ match }) => {
  const { companyId } = match.params

  return (
    <section className="tw-flex tw-h-full tw-w-full tw-flex-col">
        <ContractGroup companyId={companyId} />
    </section>
  )
}
